import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'checkNull'
})
export class CheckNullPipe implements PipeTransform {

  transform(value: string): string {
    if (value === "" || value === null || value === undefined) { return "--"; }
    if (value === 'NaN') {return '0'; }
    return value;
  }

}
